import Colors from './Colors';

export const HOVER_BACKGROUND_COLOR = Colors.N50;
export const ACTIVE_BACKGROUND_COLOR = Colors.N75;

export const HOVER_SCALE = 1.02;
export const ACTIVE_SCALE = 0.98;
